export default function asNumber(text: string | number) {
  const value: number | null = parseInt(text?.toString().trim(), 10);
  return Number.isFinite(value) ? value : null;
}
